import React, { useState } from "react"
import Box from "@mui/material/Box"
import CustomButton from "../../custom-button"
import { useDeletePlanOverride } from "../../../hooks/use-plan-override"


export default function DeletePlanOverrideForm({
    planOverrideId,
    appliancePlanId,
}: {
    planOverrideId: number,
    appliancePlanId: number,
}) {

    const [confirmation, setConfirmation] = useState<boolean>(false)

    const mutation = useDeletePlanOverride(planOverrideId, appliancePlanId)

    return (
        <Box>
            <Box display="flex" justifyContent="center" gap={1} mt={2}>
                {!confirmation &&
                    <CustomButton
                        variant="outlined"
                        color="error"    
                        text="Odstranit"
                        onClick={() => setConfirmation(true)}
                    />
                }
                {confirmation &&
                    <>
                        <CustomButton
                            color="error" 
                            text="Potvrdit"
                            disabled={mutation.isPending}
                            onClick={() => mutation.mutate()}
                        />
                        <CustomButton
                            variant="outlined"
                            text="Zrušit"
                            onClick={() => setConfirmation(false)}
                        />
                    </>
                }
            </Box>
            <Box>
                {mutation.isError ? (
                    <div>Došlo k chybě: {mutation.error.message}</div>
                ) : null}
            </Box>
        </Box>
    )
}
